import type { UsageMetricMetadata } from "../types";

// Metrics drawn as a shaded overlay on another metric's chart, keyed by that
// metric, rather than charted on their own. Each is a sub-quantity of the
// metric it overlays.
const OVERLAY_METRICS: Record<string, string> = {
  input_tokens: "cached_input_tokens",
};

const OVERLAID_METRICS = new Set(Object.values(OVERLAY_METRICS));

export const isOverlaidMetric = (metricKey: string) =>
  OVERLAID_METRICS.has(metricKey);

// The overlay for metricKey, if it has one and it is among metrics.
export const findOverlayMetric = (
  metrics: UsageMetricMetadata[],
  metricKey: string
) => metrics.find((metric) => metric.key === OVERLAY_METRICS[metricKey]);
